export default "__VITE_ASSET__B05DlMrS__"